import apiClient from '@/utils/api-client-without-base-url';

const suffixEndpoint = '/orders';

export default {
  getBalance: (date, account, type, tab) => apiClient.get(`${suffixEndpoint}/balance`, { params: { date, account, type, tab }}),
};
